const array = value => Array.isArray(value) ? value : [];
const identities = {
  company: ['fixedCompanyId', 'companyDetectorId', 'companyName'],
  dosage: ['fixedDosageId', 'dosageDetectorId', 'dosageName'],
  tag: ['fixedId', 'tagDetectorId', 'tagName'],
  category: ['fixedCatId', 'categoryDetectorId', 'catName'],
  subcategory: ['fixedSubCatId', 'subCatDetectorId', 'subCatName'],
};
// Read-only display fallback. English IDs remain the canonical relationship;
// an absent dictionary must never leave the previous language's labels behind.
export function medicineReferences(groups, language, kind) {
  const english=array(array(groups).find(group=>group.lang==='en')?.data);
  if(!language || language==='en') return english;
  const local=array(array(groups).find(group=>group.lang===language)?.data);
  function merge(base, translated, type) {
    const [fixed,detector,label]=identities[type];
    const byId=new Map();for(const row of translated)if(!byId.has(row[detector]))byId.set(row[detector],row);
    const matched=new Set();
    const result=base.map(row=>{
      const found=byId.get(row[fixed]);if(found)matched.add(found);
      const value={...row,...found,[detector]:row[fixed]};
      if(!found?.[label]?.trim()) value[label]=row[label];
      if(type==='category') value.subCatList=merge(array(row.subCatList),array(found?.subCatList),'subcategory');
      return value;
    });
    return [...result,...translated.filter(row=>!matched.has(row))];
  }
  return merge(english,local,kind);
}
export const canonicalVariantId = variant => variant?.variantDetectorId || variant?.fixedVariantId;
